import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { isFlexSelector, isOccasionSelector, leaseCarDataNameSelector } from 'store/selectors';

export const usePageTitle = (isAtThankYouStep: boolean) => {
	const isFlex = useSelector(isFlexSelector);
	const isOccasion = useSelector(isOccasionSelector);
	const leaseCarApiCarName = useSelector(leaseCarDataNameSelector);

	const [pageTitle, setPageTitle] = useState('');

	useEffect(() => {
		let plType = '';
		if (isFlex) {
			plType = ' Flex';
		} else if (isOccasion) {
			plType = ' Occasion';
		}

		let plPageTitle;

		if (!isAtThankYouStep) {
			if (leaseCarApiCarName !== '-') {
				plPageTitle = `Maandbedrag ${leaseCarApiCarName}${plType} berekenen`;
			} else {
				plPageTitle = 'Maandbedrag Private Lease berekenen';
			}
		} else if (isFlex) {
			plPageTitle = 'De aanvraag is gelukt!';
		} else {
			plPageTitle = `De aanvraag voor je Private Lease${plType} is gelukt!`;
		}

		setPageTitle(plPageTitle);
	}, [isAtThankYouStep, isFlex, isOccasion, leaseCarApiCarName]);

	return pageTitle;
};
